import { connect } from 'react-redux';
import OrderBook from '../components/exchange/OrderBook';
import actions from '../redux/actions/orderbook';

const mapDispatchToProps = (dispatch) => ({
  onFetchAllOrderBookAction: (params) => {
    dispatch(actions.fetchAllOrderBookAction(params));
  },
  onFetchBuyOrderBookAction: (params) => {
    dispatch(actions.fetchBuyOrderBookAction(params));
  },
  onFetchSellOrderBookAction: (params) => {
    dispatch(actions.fetchSellOrderBookAction(params));
  },
  onClickOrderBookBuy: (params) => {
    dispatch(actions.clickOrderBookBuy(params));
  },
  onClickOrderBookSell: (params) => {
    dispatch(actions.clickOrderBookSell(params));
  },
});

export const OrderBookContainer = connect(null, mapDispatchToProps)(OrderBook);
